import { Component, OnInit, ViewChild } from '@angular/core';

import { ErrorStateMatcher } from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import Swal from 'sweetalert2';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-adddocument',
  templateUrl: './adddocument.component.html',
  styleUrls: ['./adddocument.component.css']
})

export class AddDocumentComponent implements OnInit {
  @ViewChild('form') form: NgForm; // Reference to the form


  dataSource: any;



  // form = {
  //   moduleid: null, // Initialize form values
  //   file: null,
  //   descfile: null
  // };
  matcher = new MyErrorStateMatcher();
  displayedColumns: string[] = ['ModuleName', 'File','Description','Status','ClientName', 'Action'];
  data: object[] = [];
  modules: any[]= [];
  base64Image: any;
  MouduleSelected: any;
  AllDocuments: any;
  file: any;
  filteredData: any;
  originaldata: any;

  constructor(private GeneralService:GeneralService,private storage: AngularFireStorage) { }

  ngOnInit() {
this.getAllDocuments()
    this.retrievemodules();
    this.dataSource = new MatTableDataSource(this.AllDocuments);
console.log(this.dataSource);
  }



  // applyFilter(filterValue) {
  //   this.filteredData = this.originaldata.filter(item => {
  //     const searchTextLower = filterValue.toLowerCase();
  
  //     return (
  //       (item.question_name_en && item.question_name_en.toLowerCase().includes(searchTextLower)) ||
  //       (item.date && item.date.toLowerCase().includes(searchTextLower)) ||
  //       (item.assigneranswerdate && item.assigneranswerdate.toLowerCase().includes(searchTextLower)) ||
  //       (item.duedate && item.duedate.toLowerCase().includes(searchTextLower)) ||
  //       (item.score && item.score.toString().toLowerCase().includes(searchTextLower)) || // Assuming score is a number
  //       (item.comment && item.comment.toLowerCase().includes(searchTextLower)) ||
  //       (item.assigneranswercomment && item.assigneranswercomment.toLowerCase().includes(searchTextLower))
  //       // Add additional filtering criteria here based on your requirements
  //     );
  //   });
  //   console.log(this.filteredData.length);
  //   if(this.filteredData.length != 0){
  //     this.AllDocuments =  this.filteredData;
  //   }
  //   else{
  //     console.log("enter lenght zero 0")
  //     this.AllDocuments =  this.originaldata;

  //   }

  // }
  




  applyFilter(filterValue: string) {

    const excludedColumns = ['file', 'id','moduleId','private','clientid']; // Add more column names to exclude if needed

    // Guard clause to handle empty or non-string filter values
    if (!filterValue || typeof filterValue !== 'string') {
      filterValue = ''; // Set filterValue to empty string if it's not a valid string
    }
  
    // Trim and convert filterValue to lowercase for case-insensitive search
    const lowercaseFilterValue = filterValue.trim().toLowerCase();
  
    // Set the custom filterPredicate function
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      for (const key in data) {
        if (data.hasOwnProperty(key) && !excludedColumns.includes(key)) {
          const value = data[key];
          // Check if the property value matches the filter criteria
          if (value !== null && value !== undefined && value.toString().toLowerCase().includes(filter)) {
            return true; // Include the row in the filtered results
          }
        }
      }
      return false; // Exclude the row if no relevant property matches the filter
    };
  
    // Apply the filter to the dataSource
    this.dataSource.filter = lowercaseFilterValue;
    console.log(this.dataSource)
  }
  

  async uploadPhotos(photo: any,file:any): Promise<string[]> {
    var downloadUrls;
if(photo){
  console.log(file)
    // const photoPath = `${new Date().getTime()}.jpg`;
    // const ref = this.storage.ref(photoPath);
    // const task = ref.put(photo);
    const extension = this.getFileExtension(file.name); // Extract file extension from file name

    const photoPath = `_${new Date().getTime()}.${extension}`;
        const uploadTask = this.storage
      .ref(photoPath)
      .putString(photo,"data_url");
    // Wait for the upload task to complete
    await uploadTask.then(async (snapshot) => {
      // Get the download URL of the photo
      const downloadUrl = await snapshot.ref.getDownloadURL();
      downloadUrls=downloadUrl;
    });

  return downloadUrls;
}
else{
  return null
}
   
  }



  private getFileExtension(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || 'jpg'; // Extract and normalize file extension
  }



 getAllDocuments(){
  this.GeneralService.getallDocument().then(res=>{
    res.map(x=>{
      if(x.private=='true'){
        this.GeneralService.getclientbyid(x.clientid).then(res=>{
console.log(res)
          x.ClientName=res[0].companyname
        })
      }
      else{
        x.ClientName='';

      }
    })
    this.AllDocuments=res
    console.log(this.AllDocuments)
    this.dataSource = new MatTableDataSource(res);
    

  })
 }


  async upload(formData: any) {
    return new Promise<any>(async (resolve, reject) => {
 let url=     await this.uploadPhotos(this.base64Image,this.file);
 console.log(formData)

 let modulename= this.modules.filter(res=>res.id==formData.moduleid)[0].name
 const data={
  moduleId:formData.moduleid,
  file:url,
  desc:formData.descfile,
  private:'false',
  moduleName:modulename
 }
 console.log(data)
      this.GeneralService.addDocument(data).then(res=>{
        this.getAllDocuments();
        Swal.fire({
          title: "Success",
          text: "Your File has been Uploaded.",
          icon: "success"
        });
        resolve(res);
      }, error => {
        reject(error);
      }).catch(error => {
        // This block is executed if there is an error with the API call
        console.error("API error:", error);
        // Handle the error as needed, e.g., display an error message to the user
      });
      })


  // this.dataSource = new MatTableDataSource(this.data);
  }



  onFileSelected(event) {
    let files = event.target.files;
    console.log(files);
  
    if (files && files.length > 0) {
      // Iterate through each selected file
      for (let file of files) {
        let reader = new FileReader();
  
        // Define the onload event handler for the FileReader
        reader.onload = (e: any) => {
          // e.target.result contains the base64-encoded image data
          this.base64Image = e.target.result;
          this.file=file
          console.log(this.base64Image);
          // Push the base64 image data along with index and file info to urls array
  
          // Filter the urls array to get images specific to the current element
  
          // Assuming ActionPlan is an array that holds image information based on elements
          // If ActionPlan is an array that needs to be updated in the component,
          // use spread operator to trigger change detection
   
        };
        // reader.onloadend = (_event) =>{
        //   event.target.value = null;
        // }
  
        // Read the file as a data URL (base64-encoded image)
        reader.readAsDataURL(file);
      }
      
    }
  
  }


  Download(url: string, moduleName: string) {
    console.log(url)
    // Create a new XMLHttpRequest to fetch the file as a Blob
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
  
    xhr.onload = () => {
      // Check if the request was successful
      if (xhr.status === 200) {
        // Create a Blob from the response
        const blob = xhr.response;
  
        // Get the file name and extension from the URL
        const { fileName, fileExtension } = this.getFileNameAndExtension(url);
  
        // Create a temporary URL for the Blob
        const blobUrl = URL.createObjectURL(blob);
  
        // Create a hidden anchor element
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = `${moduleName}.${fileExtension}`; // Specify the file name with dynamic extension for download
  
        // Append the anchor to the document body (required for Firefox)
        document.body.appendChild(anchor);
  
        // Programmatically trigger a click event on the anchor to initiate the download
        anchor.click();
  
        // Clean up: revoke the Blob URL and remove the anchor element
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(anchor);
      } else {
        console.error('Failed to download file. Status:', xhr.status);
      }
    };
  
    xhr.onerror = () => {
      console.error('Error occurred while downloading file.');
    };
  
    // Send the XMLHttpRequest to fetch the file
    xhr.send();
  }

  getFileNameAndExtension(url: string): { fileName: string, fileExtension: string } {
    // Extract the part before the '?alt=media' query parameter
    const urlParts = url.split('?alt=media');
    const fileNameWithExtension = urlParts[0];
  
    // Extract the filename from the URL
    const lastSlashIndex = fileNameWithExtension.lastIndexOf('/');
    const fileName = fileNameWithExtension.substring(lastSlashIndex + 1);
  
    // Determine the file extension by splitting on the dot (.)
    const fileExtension = fileName.includes('.') ? fileName.split('.').pop() : '';
  console.log(fileExtension);
    return { fileName, fileExtension };
  }
  
  retrievemodules(): void {
    this.GeneralService
      .listofmodules()
      .then((data) => {
        this.modules = data;
        console.log(this.modules)
      });
  }
  Delete(id){
     Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!"
  }).then((result) => {
    if (result.isConfirmed) {
      this.GeneralService.removeDocument(id).then(res=>{
        this.dataSource=this.AllDocuments.filter(res=>res.id!=id)
        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success"
        });
      });

    
    }
  });
  }
  
}
